import { EmbeddedDocumentPostMessageResult } from "./index";

export class EmbeddedDocumentStatePostMessage extends EmbeddedDocumentPostMessageResult {
  constructor(
    windowName: string,
    request: string,
    public state: string
  ) {
    super(windowName, request);
  }
}
